import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import GrupoArticulosForm from '../../components/grupos-articulos/GrupoArticulosForm';
import {
  useGrupoArticulosStore,
  type ActualizarGrupoArticulos
} from '../../stores/grupos-articulos/grupos-articulos.store';

const EditarGrupoArticulos = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const navigate = useNavigate();
  const {
    current: grupo,
    actualizar,
    cargarPorId,
    eliminar
  } = useGrupoArticulosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = (values: ActualizarGrupoArticulos) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await eliminar(id);
    navigate('/grupos-agrupaciones-articulos/grupos');
  };

  return <GrupoArticulosForm grupo={grupo} onSave={handleSave} onDelete={handleDelete} />;
};

export default EditarGrupoArticulos;
